import React, { useState, useEffect } from 'react';
import SearchBar from './SearchBar';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { get, set } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import useDebounce from 'global/hooks/useDebounce';

const withSearchBar = (ListComponent) => {
  return (props) => {
    const dispatch = useDispatch();
    const store = useStore();
    const split = get(props, '_location.pathname', get(props, 'location.pathname', ''))
      .split('/')
      .filter((s) => s);
    const filter = useSelector((state) => get(state, ['filter', ...split]));

    const [searchString, changeSearchString] = useState(get(filter, 'searchstring', ''));

    useDebounce(searchString, 500, () => {
      if (filter && split.length >= 2) {
        const sState = store.getState();
        const filt = get(sState, ['filter', ...split]);
        dispatch(setFilter(split[0], split[1], set({ ...filt }, 'searchstring', searchString)));
      }

      if (props.onSearchChange) {
        props.onSearchChange(searchString);
      }
    });

    const clearSearch = () => {
      changeSearchString('');
    };

    useEffect(() => {
      changeSearchString(get(filter, 'searchstring', ''));
    }, [filter]);

    return (
      <>
        <SearchBar onClear={() => clearSearch()} changeSearch={changeSearchString} searchString={searchString} {...props} />
        <ListComponent searchString={searchString} {...props} />
      </>
    );
  };
};

export default withSearchBar;
